import { assignSafe } from './functions/assign-safe';
export interface ICoreObject {
  id: string;
  name: string;
  toShortString(): string;
}

export class CoreObject implements ICoreObject {
  constructor(jsonData?: Partial<CoreObject>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }

  id: string;
  name: string;

  toShortString(): string {
    return this.name;
  }
}
